import { graphqlClient } from '../graphqlClient';


// ==================== Get merchant webhook logs ====================

export const getWebhookLogs = async ({ merchantIds, search, page, limit }) => {
    const query = `
    query GetWebhookLogs($merchantIds: [String!]!, $search: String, $page: Float, $limit: Float) {
      webhookLogs(merchantIds: $merchantIds, search: $search, page: $page, limit: $limit) {
        data {
          id
          qr_code_id
          payment_id
          merchant_id
          event
          url
          http_status
          response_body
          error_message
          request_payload
          created_at
        }
        total
        page
        limit
        totalPages
      }
    }
  `;

    const result = await graphqlClient.query(query, {
        merchantIds,
        search,
        page,
        limit
    });

    return result.webhookLogs;
};